import { env } from '~/env.mjs';
import { withUrlParams } from '~/server/logic/url/addParams';

export const getTraceUrl = (
  identifier: { traceZipUrl: string },
  options?: {
    theme?: 'light-mode' | 'dark-mode';
    showOpenNewTab?: boolean;
    showTitle?: boolean;
  },
) => {
  const urlParams = Object.fromEntries(
    Object.entries(options ?? {})
      // the `value !== false` is required since as long as the option is present, trace viewer honors it (even false)
      .filter(([_, value]) => value !== undefined && value !== false)
      .map(([key, value]) => [key, value.toString()] as const),
  );

  return withUrlParams('https://trace.stably.ai', {
    trace: identifier.traceZipUrl,
    ...urlParams,
  });
};

// TODO: Consider deprecating this in favor of the new project-based paths
export const getRecorderTraceZipUrl = ({ testId, method, id }: { testId: string; method: 'recorder'; id: string }) => {
  const suffix = `creation/${method}/${id}.zip`;
  const path = `${testId}/traces/${suffix}`;
  return `${env.NEXT_PUBLIC_BUCKET_ORIGIN}/${path}`;
};
